import { Box, Icon, Text } from '@medely/ui-kit';
import { JobDetailsListItem } from '@mp/components/jobs';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { displayParking } from '@mp/index';
import React from 'react';
import { AssignmentForAssignmentDetailsGql } from '../../graphql';

export const AssignmentAdditionalDetailsInfoIcons = ({
  assignment: inputAssignment,
  smallIcon = false,
}: {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
  smallIcon?: boolean;
}) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  const parking = displayParking(
    assignment?.primary_location?.parking_free,
    assignment?.primary_location?.parking_reimbursed,
    assignment?.primary_location?.parking_validated,
    assignment?.primary_location?.parking_cost_cents,
  );

  return (
    <Box mb={5} testId="additional-details-group">
      <Box pb={2}>
        {!!assignment?.min_years_of_experience && (
          <JobDetailsListItem
            icon={
              <Icon
                name="light-briefcase-medical"
                iconSize={smallIcon ? '14px' : '20px'}
                color="text.primary"
                variant="custom"
              />
            }
          >
            <Text size="l">{`${assignment?.min_years_of_experience} year${
              assignment?.min_years_of_experience > 1 ? 's' : ''
            } of experience required`}</Text>
          </JobDetailsListItem>
        )}
      </Box>

      <Box pb={2}>
        <JobDetailsListItem
          icon={
            <Icon
              name="light-parking-circle"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
        >
          <Text size="l">{parking}</Text>
          <Text size="m" color="text.secondary" testId="assignment-parking-instructions">
            {assignment?.primary_location?.parking_instructions}
          </Text>
        </JobDetailsListItem>
      </Box>

      <JobDetailsListItem
        icon={
          <Icon
            name="light-tshirt"
            iconSize={smallIcon ? '14px' : '20px'}
            color="text.primary"
            variant="custom"
          />
        }
      >
        <Text size="l">{`Scrubs are${assignment?.scrubs_provided ? ' ' : ' not '}provided`}</Text>
      </JobDetailsListItem>
    </Box>
  );
};
